import { UnitOfMeasurement } from "./unitOfMeasurement.type";
import { Currency } from "./currency.type";

export enum InventoryStatus {
  AVAILABLE = "Доступно",
  IN_USE = "В использовании",
  REPAIR = "В ремонте",
  LOST = "Потеряно",
  UNAVAILABLE = "Недоступно",
  IN_STORAGE = "В складе",
  WRITTEN_OFF = "Списанный",
  SOLD = "Продано",
}

export interface InventoryItem {
  _id: string;
  userId: string;
  username: string;
  name: string;
  quantity: number;
  unitOfMeasurement: UnitOfMeasurement;
  description?: string;
  status: InventoryStatus;
  date: string;
  lastUpdate: string;
  price: number;
  total: number;
  currency: Currency;
  trackingId: string;
}
